var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#2AABEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.42 7.74L15.7 16.23C15.57 16.83 15.23 16.98 14.72 16.7L11.98 14.68L10.66 15.95C10.52 16.09 10.39 16.22 10.11 16.22L10.31 13.42L15.41 8.81C15.64 8.61 15.36 8.49 15.06 8.69L8.76 12.66L6.05 11.81C5.46 11.62 5.45 11.22 6.18 10.93L16.76 6.85C17.25 6.67 17.68 6.97 17.42 7.74Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7344935c3b184ff821440ff47b37af63.svg";
export { ForwardRef as ReactComponent };